import {createElement, Component, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';
import Main from 'components/main';
import css from 'static/style/dow.less';
import {fromJS} from 'immutable';
import contentLoader from 'helpers/content-loader';
import ShopListing from 'rlink-shop/components/ShopListing';
import NavLink from 'rlink-router/NavLink';
import {SKU_GROUPS, REGION_RESTRICTIONS} from 'region-config';
import {DOW} from 'terms';

import getUserSelectedCountry from 'rlink-regions/getUserSelectedCountry';
import getCountryFromPreferredLanguages from 'rlink-regions/getCountryFromPreferredLanguages';
import getRegionForCountry from 'rlink-regions/getRegionForCountry';
import getPreferredLanguages from 'rlink-regions/getPreferredLanguages';

import DocumentTitle from 'rlink-react-document/DocumentTitle.jsx';
import DocumentOpenGraphProperty from 'rlink-react-document/DocumentOpenGraphProperty.jsx';

export default function (params, content) {
  let preferredLanguages = getPreferredLanguages();
  let userCountry = getUserSelectedCountry();
  if (userCountry === null) {
    userCountry = getCountryFromPreferredLanguages(preferredLanguages);
  }
  let items = content.products.data.get('items').toJS().filter(item => {
    if (!item.viewsWhitelist.includes('buy')) {
      return false;
    }

    if (!('skuGroups' in item)
      || item.skuGroups.length === 0
      || item.hasRestrictions === false) {
      return true;
    }

    for (let skuGroup of item.skuGroups) {
      if (skuGroup in SKU_GROUPS && SKU_GROUPS[skuGroup].includes(userCountry)) {
        return true;
      }
    }

    return false;
  });

  let pageTitle = <FormattedMessage
    id="ui.label.title.BUY_PAGE_TITLE"
    defaultMessage="Buy"
    description="Page title of the buy page" />;
  let pageDescription = <FormattedMessage
    id="ui.text.description.BUY_PAGE_DESCRIPTION"
    defaultMessage="Dawn of War official store"
    description="Description for the buy page" />;

  return (<Main globalSettings={content.globalSettings}>
    <DocumentTitle title={pageTitle} site={DOW} />
    <DocumentOpenGraphProperty property="url" value="https://www.dawnofwar.com/buy" />
    <DocumentOpenGraphProperty property="title" value={pageTitle} />
    <DocumentOpenGraphProperty property="description" value={pageDescription} />
    <DocumentOpenGraphProperty property="image" value={items[0].backgroundPath} />
    <div key="buy">
      <div className={css['content-panel']}>
        <div className={`${css['panel-content']} ${css['buy-page-content']}`}>
          <ShopListing css={css}
            region={params.region || getRegionForCountry(userCountry, SKU_GROUPS, REGION_RESTRICTIONS).toString()}
            defaultRatingsBoard={content.globalSettings.defaultRatingsBoard}
            shopItems={fromJS(items)}
            slug={params && 'slug' in params ? params.slug : ''}
            skuGroups={SKU_GROUPS}
            userCountry={userCountry} />
        </div>
      </div>
      <div className={css['powered-by']}>
        <FormattedMessage
          id="ui.label.title.STORE_POWERED_BY"
          defaultMessage="store powered by:"
          description="Heading for showing the third-part vendor handling the store." />
        <NavLink href={{
          view: 'humble-bundle-disclaimer',
          params: {bare: true},
          modal: true,
        }}>
          <img src={contentLoader('humble-bundle-logo.png')} />
        </NavLink>
      </div>
    </div>
  </Main>);
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/views/buy.jsx